export default __webpack_public_path__ + "static/media/Planhyvlat 20.7a58b76a.jpg";